import { type QueryHookOptions, useQuery } from "@apollo/client";
import { AnalyticsViewsByCountryQuery } from "../graphql/queries";
import type {
  AnalyticsViewsByCountryQueryType,
  AnalyticsViewsByCountryQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useAnalyticsViewsByCountryQuery = (
  options?: QueryHookOptions<
    AnalyticsViewsByCountryQueryType,
    AnalyticsViewsByCountryQueryVariablesType
  >
) => {
  return useQuery<
    AnalyticsViewsByCountryQueryType,
    AnalyticsViewsByCountryQueryVariablesType
  >(AnalyticsViewsByCountryQuery, options);
};
